"use client"

import * as React from "react"

import { DropdownMenuSubTrigger } from "@/components/ui/dropdown-menu"
import { cn } from "@/lib/utils"

export interface ProfileMenuSubTriggerProps
  extends React.ComponentProps<typeof DropdownMenuSubTrigger> {
  iconClassName: string
  label: string
  trailing?: React.ReactNode
}

/**
 * Profile-menu submenu row with a right-aligned trailing value.
 *
 * `DropdownMenuSubTrigger` appends a chevron with `ms-auto`. A second
 * `ms-auto` on the trailing value parks it between the label and chevron.
 */
export function ProfileMenuSubTrigger({
  iconClassName,
  label,
  trailing,
  className,
  children,
  ...props
}: ProfileMenuSubTriggerProps) {
  return (
    <DropdownMenuSubTrigger className={cn("gap-2", className)} {...props}>
      <span className="flex min-w-0 flex-1 items-center gap-1.5">
        <i className={iconClassName} aria-hidden="true" />
        <span className="truncate">{label}</span>
        {children}
      </span>
      {trailing != null && trailing !== "" ? (
        <span className="max-w-[9rem] shrink-0 truncate text-end text-xs text-muted-foreground tabular-nums">
          {trailing}
        </span>
      ) : null}
    </DropdownMenuSubTrigger>
  )
}
